import React from "react";

import { Box, Divider } from "@mui/material";

import { useScreenSize } from "globals/hooks";
import { Trip } from "types";
import AdditionalTripInfoBlock from "./components/TripItineraryCard/components/AdditionalTripInfoBlock";
import TripItineraryCard from "./components/TripItineraryCard/TripItineraryCard";
import VehicleCard from "./components/VehicleCard";
import VehicleCategoryCard from "./components/VehicleCategoryCard";
import DriverCard from "./components/DriverCard";
import SolicitChangeBanner from "./SolicitChangeBanner";
import first from "lodash/first";

type TripDetailsUpdateBlockProps = {
  isQuote: boolean;
  isReservationRequest?: boolean;
  orderNumber: string;
  activeTrip: Trip;
  tripTabs?: React.ReactNode;
  hideRequestChangeBanner?: boolean;
};

function TripDetailsUpdateBlock(props: TripDetailsUpdateBlockProps) {
  const {
    isQuote,
    isReservationRequest,
    activeTrip,
    tripTabs,
    orderNumber,
    hideRequestChangeBanner,
  } = props;

  // hooks
  const { isTabletView, isMobileView } = useScreenSize();

  // derived state
  const route = first(activeTrip.routes);
  const hasVehicleCategory = route?.vehicleCategory && !route?.vehicle;
  const driver = route?.driver;
  const isRoundTrip = !!activeTrip.roundTripVariant;
  return (
    <>
      <Box
        display="flex"
        flex="3"
        flexDirection="column"
        {...(!isTabletView && { mr: 2 })}
      >
        {tripTabs && <Box mb={2}>{tripTabs}</Box>}

        {!hideRequestChangeBanner && (
          <SolicitChangeBanner
            trip={activeTrip}
            isReservationRequest={isReservationRequest}
          />
        )}
        <Box mb={2}>
          <TripItineraryCard
            mode="update"
            isQuote={isQuote}
            orderNumber={orderNumber}
            hasReturnTrip={!!activeTrip.returnTrip}
            trip={activeTrip}
            additionalTripInfoBlock={
              <AdditionalTripInfoBlock
                mode="update"
                trip={activeTrip}
                passenger={activeTrip.contact}
                isRoundTrip={isRoundTrip}
              />
            }
          />
          <Box my={2}>
            {hasVehicleCategory ? (
              <VehicleCategoryCard vehicleCategory={route.vehicleCategory} />
            ) : (
              <VehicleCard vehicle={route.vehicle} />
            )}
          </Box>
          <Box my={2}>
            <DriverCard driver={driver} />
          </Box>

          {/* return trip */}
          {activeTrip.returnTrip && (
            <>
              <Divider sx={{ mt: 3 }} />
              {!isQuote && (
                <Box mb={3}>
                  <SolicitChangeBanner trip={activeTrip.returnTrip} />
                </Box>
              )}
              <Box
                display="flex"
                flexDirection={isMobileView ? "column" : "row"}
                pt={3}
              />
              <TripItineraryCard
                mode="update"
                isQuote={isQuote}
                orderNumber={orderNumber}
                isReturnTrip
                trip={activeTrip.returnTrip}
                additionalTripInfoBlock={
                  <AdditionalTripInfoBlock
                    mode="update"
                    trip={activeTrip.returnTrip}
                    passenger={activeTrip.returnTrip.contact}
                    isRoundTrip={true}
                  />
                }
              />
            </>
          )}
        </Box>
      </Box>
    </>
  );
}

export default TripDetailsUpdateBlock;
